// extracted by mini-css-extract-plugin
export default {"content":"NoContent_content__KAaQT"};